<template>
    <div class="bread-crumbs">
        <router-link
            v-for="item in routesPath"
            :key="item.to.name"
            :to="item.to"
            class="bread-crumbs__item uppercase-first-letter"
            exact-active-class="bread-crumbs__item--active"
            rel="noopener noreferrer"
        >
            {{ $t(`${item.text}`) }}/
        </router-link>
    </div>
</template>

<script>
export default {
    name: 'BreadCrumbsComponent',
};
</script>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { ROUTE_NAMES } from '@/router/router-names';

const route = useRoute();

const routesPath = computed(() =>
    route.matched
        .filter(el => el.name !== undefined && el.name !== null)
        .map(el => ({
            text: (el.meta?.title?.value || (ROUTE_NAMES[el.name] && ROUTE_NAMES[el.name].label)),
            to: { name: el.name },
        })),
);
</script>

<style src='./styles.scss' lang='scss' scoped />
